import * as React from 'react'
import { Text, View, StyleSheet } from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  stat: {
    fontFamily: Fonts.type.bold,
  },
  primary: {
    fontSize: 36,
  },
  secondary: {
    fontSize: 22,
  },
  profile: {
    fontSize: 30,
    color: Colors.white,
    paddingTop: 10,
    marginBottom: -2,
  },
  label: {
    fontSize: Fonts.size.small,
    fontFamily: Fonts.type.alternateBold,
    color: Colors.textGray,
  },
  profileLabel: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.regular,
    color: Colors.alternateGray,
    opacity: 0.6,
  },
})

export function Stat({
  type,
  stat,
  label,
}: {
  type: 'primary' | 'secondary' | 'profile'
  stat: string
  label: string
}) {
  const getStatType = () => {
    switch (type) {
      case 'primary':
        return styles.primary
      case 'secondary':
        return styles.secondary
      case 'profile':
        return styles.profile
      default:
        return undefined
    }
  }
  return (
    <View
      style={[
        styles.container,
        type === 'profile' && { alignItems: 'flex-start', flex: 1 },
      ]}
    >
      <Text style={[styles.stat, getStatType()]}>{stat}</Text>
      <Text style={[styles.label, type === 'profile' && styles.profileLabel]}>
        {label}
      </Text>
    </View>
  )
}
